import React from "react";
import PropTypes from "prop-types";
import "./css/overlay.css";

const Overlay = ({ children, closeOverlay, className }) => (
  <div className="overlay__ui-blocker">
    <div className={`overlay__container ${className}`}>
      <button
        data-quid="overlay-close"
        type="button"
        className="close-overlay"
        onClick={closeOverlay}
      >
        X
      </button>
      {children}
      <div className="triangle" />
    </div>
  </div>
);

Overlay.propTypes = {
  children: PropTypes.arrayOf(PropTypes.any.isRequired).isRequired,
  closeOverlay: PropTypes.func.isRequired,
  className: PropTypes.string
};

Overlay.defaultProps = {
  className: ""
};

export default Overlay;
